<div class="dialog-form report-form">
  <div class="dialog-form__close">
    <a mat-dialog-close>
      <mat-icon>close</mat-icon>
    </a>
  </div>
  <header mat-dialog-title class="dialog-form__title">
    <h2>Place of Service Crosswalk</h2>
  </header>
  <main mat-dialog-content>
    <div class="dialog-form__container">
      <form [formGroup]="formGroup" class="place-of-service-form">
        <ng-container *ngFor="let crosswalk of crosswalks">
          <div class="place-of-service-form__label">
            {{ crosswalk.originalPlaceOfServiceCode }} - {{ crosswalk.originalPlaceOfServiceName }}
          </div>
          <mat-form-field appearance="outline" class="place-of-service-form__select">
            <select matNativeControl [formControlName]="'placeOfServiceCode' + crosswalk.originalPlaceOfServiceCode">
              <option value=""></option>
              <option *ngFor="let option of placeOfServiceOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </mat-form-field>
        </ng-container>
      </form>
    </div>
  </main>
  <div mat-dialog-actions class="buttons">
    <ng-container *ngIf="formInitialized; else loading">
      <button mat-stroked-button mat-dialog-close *ngIf="viewOnly">Close</button>
      <button class="cancel-button" mat-stroked-button mat-dialog-close *ngIf="!viewOnly">Cancel</button>
      <lib-button-loading
        *ngIf="!viewOnly"
        color="primary"
        class="save-button"
        [loading]="saving"
        [invalid]="formGroup.invalid"
        (clickEvent)="save()"
        >Save
      </lib-button-loading>
    </ng-container>
  </div>
  <ng-template #loading>
    <div class="loading">
      <mat-spinner [diameter]="150"></mat-spinner>
    </div>
  </ng-template>
</div>
